import React from 'react';
import { useTranslation } from 'react-i18next';
import { useGetRequestsQuery } from '../../api/requestApiSlice';
import useCustomTable from '../tables/useCustomTable';
import Table from '../tables/Table';
import Block from '../Block';
import { Loader } from '../components';

const RequestList = ({sptId}) => {
  const { t } = useTranslation();
  const { data: requests=[], isLoading, isSuccess } = useGetRequestsQuery(sptId)
  const columns = [{
    Header: 'Created At',
    accessor: 'created_at',
    Cell: ({row}) => (<Date dateFormat = 'long' date={row.original.date}/>),
  },{
    Header: "Action",
    accessor: "action"
  },{
    Header: "Response code",
    accessor: "response_code"
  },{
    Header: "Params",
    accessor: "params",
    Cell: ({row}) => (<>{JSON.stringify(row.original.params, null, 2)}</>),

  },{
    Header: "Response body",
    accessor: "response_body",
    Cell: ({row}) => (<>{JSON.stringify(row.original.body, null, 2)}</>),
  }]

  const {
    tableProps
  } = useCustomTable({
    sortable: true,
    paginate: false,
    filterable: false,
  })

  return (
    <Block title={t("devices.requests")}>
      <Loader success={!isLoading && isSuccess} error={!isLoading && !isSuccess}>
        <Table data={requests} columns={columns} {...tableProps} />
      </Loader>
    </Block>
  )
}

export default RequestList